// extracted by mini-css-extract-plugin
export var infoItem = "_nk-2";
export var title = "_nk-0";
export var value = "_nk-1";